// @ts-nocheck
import { ButtonIcon } from "@insite/mobius/Button";
import buttonTypes from "@insite/mobius/Button/buttonTypes";
import { resolveColor } from "@insite/mobius/utilities";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import { ButtonProps } from "@store/MobiusOverrides/Button/Props";
import { css } from "styled-components";

type ButtonTypesProps<T extends (...args: any) => any> = Parameters<T>[0] & Pick<ButtonProps, "hoverTextColor">;

const baseButtonTypes = { ...buttonTypes };

Object.assign(buttonTypes, {
    solid: (props: ButtonTypesProps<typeof buttonTypes.solid>) => {
        const contrastColor = getContrastColor(props._color, props.theme);
        const hoverTextColor = resolveColor(props.hoverTextColor, props.theme);

        return css`
            ${baseButtonTypes.solid(props)}

            ${ButtonIcon} {
                color: ${contrastColor};
            }

            &:not(:disabled):hover {
                color: ${hoverTextColor};

                ${ButtonIcon} {
                    color: ${hoverTextColor};
                }
            }
        `;
    },
    outline: (props: ButtonTypesProps<typeof buttonTypes.outline>) => {
        const contrastColor = getContrastColor(props._color, props.theme);
        const hoverTextColor = resolveColor(props.hoverTextColor, props.theme);
        const hoverColor = resolveColor(props.hoverStyle?.color, props.theme); /* Store Custom Code */

        return css`
            ${baseButtonTypes.outline(props)}

            ${ButtonIcon} {
                color: ${contrastColor};
            }

            &:not(:disabled):hover {
                color: ${hoverTextColor};
                background-color: ${hoverColor}; /* Store Custom Code */

                ${ButtonIcon} {
                    color: ${hoverTextColor};
                }
            }
        `;
    },
});
